<div class="container" *ngIf="!isResponsive">
  <div class="stepper-wrapper">
    <div class="progress-line">
      <div class="progress" [style.height.%]="progressPercent"></div>
    </div>
    
    <ol class="steps">
      <li *ngFor="let step of steps; let i = index" class="step" [ngClass]="step.status"
        [attr.aria-current]="step.status === 'current' ? 'step' : null">
        
        <button class="btn" [disabled]="step.status === 'pending' || step.status === 'current'"
          [routerLink]="step.path">
          <ion-icon *ngIf="step.status === 'complete'" name="checkmark"></ion-icon>
          <span class="btn-number" *ngIf="step.status !== 'complete'"></span>
        </button>

        <div class="title" [ngClass]="{'pending-title': step.status === 'pending'}">
          <p class="title-paso">Paso {{ step.id }}</p>
          <p class="title-main">{{ step.title }}</p>
          <p class="subtitle">{{ step.subTitle }}</p>

          <div class="nav" *ngIf="step?.nav_index">
            <p class="subtitle">{{ step.stepInfo }}</p>
            <p class="underline" *ngFor="let index of step?.nav_index">
              <a [href]="step?.url + '#' + index?.id">{{ index?.name }}</a>
            </p>
          </div>
        </div>
      </li>
    </ol>
  </div>
</div>

<div class="container" *ngIf="isResponsive">
  <ion-accordion-group>
    <ion-accordion value="first">
      <ion-item slot="header" class="item-current-step">
        <div class="header-content">
          <ion-label><span class="currentStepResponsive">{{ currentStepResponsive }}</span> - {{
            titleCurrentStepResponsive }}</ion-label>
          <ion-progress-bar [value]="calculateProgress()"></ion-progress-bar>
        </div>
      </ion-item>

      <div class="ion-padding" slot="content">
        <div *ngFor="let step of steps; let i = index" class="step" [ngClass]="step.status">
          <button class="btn" [disabled]="step.status == 'pending' || step.status == 'current'"
            [routerLink]="[step.path]">
            <ion-icon name="checkmark"></ion-icon>
          </button>
          <div class="title" [ngClass]="{'pending-title': step.status === 'pending'}">
            <p>Paso {{ i + 1 }}</p>
            <p class="title-main">{{ step.title }}</p>
            <p class="subtitle">{{ step.subTitle }}</p>
          </div>
        </div>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>